import { useSyncExternalStore } from 'react'
import { readPlannerLocation, writePlannerLocation } from './plannerLocation'
const subscribe = callback => {
  window.addEventListener('popstate', callback)
  window.addEventListener('heliview:location', callback)
  return () => { window.removeEventListener('popstate', callback); window.removeEventListener('heliview:location', callback) }
}
export function usePlannerLocation(saved = {}) {
  const search = useSyncExternalStore(subscribe, () => window.location.search, () => '')
  const state = readPlannerLocation(search, saved)
  function update(patch, push = false) {
    const current = readPlannerLocation(window.location.search, saved)
    const next = typeof patch === 'function' ? patch(current) : { ...current, ...patch }
    const url = `${window.location.pathname}${writePlannerLocation(window.location.search, next)}${window.location.hash}`
    window.history[push ? 'pushState' : 'replaceState'](window.history.state, '', url)
    window.dispatchEvent(new Event('heliview:location'))
  }
  return [state, update]
}
